module.exports = __webpack_public_path__ + "img/fire-icon.498fcc83.svg";